
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.922.422l-.547 1.375h1.219v1.086H6.945l-1.164 2.93h2.813v1.085h-3.25l-1.18 2.977c.198.026.482.04.852.04h3.578V11h-3.61a7.81 7.81 0 01-1.234-.078l-.578 1.453h-.906l.656-1.656a2.658 2.658 0 01-1.156-.774 4.507 4.507 0 01-.454-.586 4.02 4.02 0 01-.351-.734 5.248 5.248 0 01-.242-.977 7.818 7.818 0 01-.086-1.195c0-.823.08-1.502.242-2.039.161-.542.432-1.02.813-1.437a3.22 3.22 0 011.367-.907c.53-.182 1.218-.273 2.062-.273H6.47L7.016.422h.906zm-6.047 5.39h2.992l1.164-2.93H5.11c-.515 0-.935.03-1.257.087a2.311 2.311 0 00-.797.281 2.025 2.025 0 00-.586.54 2.733 2.733 0 00-.406.866 5.26 5.26 0 00-.188 1.157zm1.469 3.86l1.094-2.774h-2.57c.04.771.184 1.38.429 1.829.245.442.594.757 1.047.945z","fill":"currentColor"}})])
          )
        }
      }
    